import { Dayjs } from 'dayjs';
import dayjs from 'common/config/dayjs.config';
import { IPeakHours } from 'entities/PeakHours/PeakHours.models';

const incrementForNextTime = 15;
const incrementAsap = 20;
const incrementASAPForBusy = 30;

const loopBreakValue = 20;

const gapBeforeClosing = 30;
const gapAfterOpening = 30;

const BETimeFormat = 'HH:mm:ss';

export const formatTime = (time: Dayjs, format: string = 'h:mm A') => {
  return time.format(format);
};

export const getTimeList = (
  open: Dayjs,
  close: Dayjs,
  peakHours: IPeakHours | null,
): {
  times: Dayjs[];
  asapIncrement?: number;
  asap?: Dayjs;
} => {
  const result: Dayjs[] = [];

  const currentTime: Dayjs = dayjs();

  if (!currentTime || !onOpenHours(currentTime, open, close)) {
    return { asap: undefined, times: [] };
  }

  const asapIncrement = getASAPIncrement(currentTime, peakHours, open);
  const asap = currentTime.add(asapIncrement, 'minutes');

  if (!onOpenHours(asap, open, close)) {
    return { asap: undefined, times: [] };
  }

  let i = 0;

  while (i <= loopBreakValue) {
    const previous: Dayjs = result[i - 1] || asap;
    const item = previous.add(incrementForNextTime, 'minutes');

    if (!onOpenHours(item, open, close)) {
      break;
    }

    result.push(item);

    i = i + 1;
  }

  return { asap, asapIncrement, times: result };
};

const onOpenHours = (time: Dayjs, open: Dayjs, close: Dayjs): boolean => {
  return time.isBetween(open, close.subtract(gapBeforeClosing, 'minutes'), null, '[]');
};

const onBusyHours = (time: Dayjs, peakHours: IPeakHours | null): boolean => {
  if (!peakHours?.peakHours.length) {
    return false;
  }

  return peakHours.peakHours.some(({ begin, end }) => {
    return time.isBetween(dayjs(begin, BETimeFormat), dayjs(end, BETimeFormat), null, '[]');
  });
};

const getASAPIncrement = (time: Dayjs, peakHours: IPeakHours | null, open: Dayjs): number => {
  if (time.isSameOrBefore(open.add(gapAfterOpening, 'minutes'), 'minute')) {
    return incrementASAPForBusy;
  }

  return onBusyHours(time, peakHours) ? incrementASAPForBusy : incrementAsap;
};
